var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _g, _rect2, _g2, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoicecloningInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 130,
    viewBox: "0 0 153 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153 54.7304C153 60.3004 150.909 65.6653 147.144 69.7525C143.379 73.8398 138.219 76.3483 132.693 76.7765C132.507 76.7907 132.318 76.8049 132.129 76.8134V55.8275C132.129 55.6177 132.083 55.4106 131.993 55.2213C131.903 55.0319 131.773 54.8652 131.61 54.7333C131.592 54.7139 131.571 54.6968 131.548 54.6822C131.528 54.6655 131.506 54.6503 131.483 54.6369C131.285 54.5087 131.058 54.4325 130.823 54.4151C130.588 54.3978 130.353 54.4399 130.138 54.5377L129.904 54.0217C130.16 53.9046 130.438 53.8437 130.719 53.8431L114.654 39.9329C114.778 39.7911 114.908 39.6522 115.038 39.5133C118.066 36.3044 121.983 34.0822 126.281 33.1336C130.579 32.1851 135.062 32.5539 139.149 34.1923C143.237 35.8308 146.741 38.6637 149.21 42.3249C151.68 45.9861 153 50.3074 153 54.7304Z",
    fill: "#FFE3A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.129 54.4377C132.132 54.5083 132.108 54.5772 132.061 54.6305C132.013 54.6876 131.944 54.723 131.869 54.7288C131.795 54.7347 131.721 54.7105 131.664 54.6616L130.719 53.8424L114.654 39.9321L69.5962 0.911399C69.3392 0.690239 69.0118 0.568932 68.6734 0.569452C68.3351 0.569972 68.0081 0.692283 67.7517 0.914232L7.07438 53.8991L6.52725 54.3753C6.50621 54.394 6.48242 54.4093 6.45674 54.4207C6.41157 54.4408 6.36195 54.4486 6.31283 54.4434C6.24239 54.4358 6.17716 54.4025 6.12953 54.3498C6.10503 54.3219 6.08625 54.2895 6.07426 54.2543C6.06227 54.2191 6.0573 54.1818 6.05965 54.1447C6.062 54.1076 6.07163 54.0713 6.08797 54.0379C6.10431 54.0045 6.12704 53.9747 6.15487 53.9501L6.23102 53.8821L67.3822 0.486182C67.7415 0.175979 68.1992 0.0049505 68.6729 0.00391102C69.1465 0.00287154 69.6049 0.171889 69.9656 0.480511L115.038 39.5126L132.031 54.2308C132.06 54.2566 132.084 54.2883 132.101 54.3239C132.118 54.3595 132.128 54.3982 132.129 54.4377Z",
    fill: "#3F3D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9639 26.479C70.6439 25.596 69.9885 24.8767 69.1415 24.4786C68.2945 24.0806 67.3251 24.0364 66.4457 24.3557L41.0568 33.6113L28.7968 38.0789C28.3612 38.2372 27.9608 38.4802 27.6187 38.794C27.2766 39.1079 26.9993 39.4864 26.8028 39.908C26.6064 40.3296 26.4945 40.786 26.4736 41.2511C26.4527 41.7162 26.5232 42.1809 26.681 42.6186C26.8389 43.0563 27.0811 43.4584 27.3937 43.802C27.7063 44.1455 28.0832 44.4238 28.5028 44.6209C28.9225 44.818 29.3767 44.93 29.8394 44.9505C30.3022 44.9711 30.7644 44.8998 31.1997 44.7406L41.0568 41.149L68.8516 31.0203C69.7301 30.6986 70.4457 30.0399 70.8417 29.1885C71.2377 28.3372 71.2817 27.3628 70.9639 26.479Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4343 38.8716C75.1142 37.9886 74.4589 37.2692 73.6119 36.8712C72.7649 36.4732 71.7955 36.429 70.9161 36.7483L66.6151 38.3159L41.0569 47.631L33.2672 50.4686C32.3887 50.7895 31.6729 51.4479 31.2771 52.2989C30.8813 53.15 30.8379 54.1242 31.1564 55.0074C31.4748 55.8907 32.1291 56.6107 32.9755 57.0093C33.8219 57.4079 34.7911 57.4525 35.6701 57.1332L41.0569 55.1687L73.3219 43.41C73.3952 43.3845 73.4657 43.3533 73.5362 43.3222C74.3554 42.9609 75.0073 42.3001 75.3598 41.4736C75.7122 40.6472 75.7389 39.717 75.4343 38.8716Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9525 51.3969C79.6331 50.5141 78.9783 49.7947 78.1318 49.3967C77.2852 48.9986 76.3161 48.9544 75.4372 49.2737L63.3745 53.6704L54.0362 57.075L41.0569 61.8034L37.7854 62.9968C37.0293 63.2737 36.3898 63.8017 35.9729 64.4934C35.5559 65.1852 35.3864 65.9993 35.4923 66.8011C35.5246 67.0397 35.5814 67.2744 35.6616 67.5013L40.3039 69.616L41.0569 69.3411H41.0625L64.6154 60.7574L77.84 55.9382C78.719 55.6172 79.4353 54.9585 79.8314 54.107C80.2275 53.2555 80.271 52.2807 79.9525 51.3969Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5173 14.2934C53.1972 13.4105 52.5418 12.6911 51.6948 12.2931C50.8479 11.8951 49.8784 11.8509 48.9991 12.1702L34.4177 17.4826C33.5393 17.8035 32.8235 18.4618 32.4277 19.3128C32.0319 20.1639 31.9885 21.1381 32.3069 22.0213C32.6254 22.9046 33.2797 23.6246 34.1261 24.0232C34.9724 24.4218 35.9416 24.4664 36.8207 24.1471L41.4349 22.4661L44.4892 21.352L51.4049 18.8319C52.2832 18.5108 52.9989 17.8526 53.3949 17.0018C53.7909 16.1509 53.8349 15.1769 53.5173 14.2934Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6051 53.6699H57.556C56.6453 53.6705 55.7702 54.0252 55.1141 54.6599C54.4579 55.2946 54.0716 56.1599 54.0362 57.0745C54.0315 57.1206 54.0296 57.167 54.0305 57.2134C54.0318 58.1528 54.4037 59.0533 55.0645 59.7176C55.7254 60.3818 56.6214 60.7555 57.556 60.7569H97.6051C98.5401 60.7569 99.4368 60.3835 100.098 59.719C100.759 59.0545 101.131 58.1532 101.131 57.2134C101.131 56.2736 100.759 55.3723 100.098 54.7078C99.4368 54.0433 98.5401 53.6699 97.6051 53.6699Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8869 67.6963C99.2512 67.1497 98.4417 66.85 97.6051 66.8516H57.556C56.621 66.8516 55.7243 67.2249 55.0631 67.8894C54.402 68.554 54.0305 69.4553 54.0305 70.395C54.0305 71.3348 54.402 72.2361 55.0631 72.9007C55.7243 73.5652 56.621 73.9385 57.556 73.9385H87.5506L100.31 68.1244C100.181 67.9699 100.04 67.8267 99.8869 67.6963Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4816 80.1738L67.8559 82.1667C68.1121 82.283 68.39 82.3432 68.6711 82.3432C68.9522 82.3432 69.23 82.283 69.4862 82.1667L73.8605 80.1738H63.4816Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6477 38.5637C88.3995 37.8815 87.9488 37.2925 87.3565 36.8762C86.7643 36.46 86.0592 36.2366 85.3365 36.2363H69.8245C69.1473 36.237 68.4846 36.4335 67.9154 36.8024C67.3463 37.1714 66.8949 37.6972 66.615 38.3171C66.4061 38.7761 66.2983 39.275 66.2991 39.7798C66.3004 40.7192 66.6722 41.6197 67.3331 42.284C67.994 42.9482 68.8899 43.322 69.8245 43.3233H85.3365C85.9037 43.3233 86.4625 43.1858 86.9654 42.9225C87.4684 42.6591 87.9008 42.2777 88.2258 41.8105C88.5508 41.3434 88.7588 40.8043 88.8323 40.239C88.9057 39.6738 88.8424 39.0991 88.6477 38.5637Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2535_1791",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 8,
    width: 92,
    height: 92
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 31.9668,
    width: 73,
    height: 73,
    rx: 4,
    transform: "rotate(-20 0 31.9668)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2535_1791)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.320428,
    y: 32.1162,
    width: 72.5,
    height: 72.5,
    rx: 3.75,
    transform: "rotate(-20 0.320428 32.1162)",
    fill: "#FEC335",
    stroke: "#1F1074",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.429 56.3533L20.7703 56.957L21.1378 57.9668L22.7965 57.3631L22.429 56.3533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6849 46.7986L47.0262 47.4023L47.3938 48.4121L49.0525 47.8084L48.6849 46.7986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3106 45.8416L49.6519 46.4453L50.0194 47.4551L51.6781 46.8514L51.3106 45.8416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4386 41.0642L62.7799 41.668L63.1474 42.6778L64.8062 42.0741L64.4386 41.0642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0399 71.6971L23.3812 72.3008L23.7488 73.3107L25.4075 72.707L25.0399 71.6971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.458 70.0994L22.7993 70.7031L23.1669 71.713L24.8256 71.1093L24.458 70.0994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7129 65.3045L21.0542 65.9082L21.4218 66.9181L23.0805 66.3144L22.7129 65.3045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2943 66.9002L21.6356 67.5039L22.0031 68.5138L23.6618 67.9101L23.2943 66.9002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.131 63.7049L20.4723 64.3086L20.8398 65.3184L22.4985 64.7147L22.131 63.7049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8761 68.4998L22.2174 69.1035L22.5849 70.1133L24.2436 69.5096L23.8761 68.4998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0448 64.0525L44.3861 64.6562L44.7537 65.6661L46.4124 65.0624L46.0448 64.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4192 65.0076L41.7605 65.6113L42.1281 66.6212L43.7868 66.0175L43.4192 65.0076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.168 66.9197L36.5093 67.5234L36.8769 68.5333L38.5356 67.9296L38.168 66.9197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9215 61.1853L52.2628 61.7891L52.6304 62.799L54.2891 62.1952L53.9215 61.1853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6703 63.0975L47.0116 63.7012L47.3792 64.7111L49.0379 64.1074L48.6703 63.0975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5424 67.8748L33.8837 68.4785L34.2513 69.4884L35.91 68.8847L35.5424 67.8748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2959 62.1404L49.6372 62.7441L50.0048 63.754L51.6635 63.1503L51.2959 62.1404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7567 62.7498L23.098 63.3535L23.4655 64.3633L25.1242 63.7596L24.7567 62.7498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9199 65.9451L24.2612 66.5488L24.6287 67.5587L26.2874 66.955L25.9199 65.9451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3385 64.3475L23.6798 64.9512L24.0474 65.9611L25.7061 65.3574L25.3385 64.3475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5472 60.2303L54.8885 60.834L55.2561 61.8439L56.9148 61.2402L56.5472 60.2303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5018 67.5447L24.8431 68.1484L25.2106 69.1582L26.8693 68.5545L26.5018 67.5447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0836 69.1424L25.4249 69.7461L25.7925 70.756L27.4512 70.1523L27.0836 69.1424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9168 68.8299L31.2581 69.4336L31.6257 70.4435L33.2844 69.8398L32.9168 68.8299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2912 69.7869L28.6325 70.3906L29.0001 71.4005L30.6588 70.7968L30.2912 69.7869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6655 70.742L26.0068 71.3457L26.3744 72.3556L28.0331 71.7519L27.6655 70.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.424 57.3631L62.7653 57.9668L63.1329 58.9767L64.7916 58.373L64.424 57.3631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7984 58.3182L60.1397 58.9219L60.5073 59.9318L62.166 59.3281L61.7984 58.3182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0496 56.408L65.3909 57.0117L65.7584 58.0216L67.4171 57.4179L67.0496 56.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6752 55.451L68.0165 56.0547L68.3841 57.0646L70.0428 56.4609L69.6752 55.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1747 61.1502L22.516 61.7539L22.8836 62.7638L24.5423 62.1601L24.1747 61.1502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3008 54.4959L70.6421 55.0996L71.0097 56.1095L72.6684 55.5058L72.3008 54.4959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7597 59.865L16.101 60.4688L16.4685 61.4786L18.1272 60.8748L17.7597 59.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9235 63.0623L17.2648 63.666L17.6323 64.6759L19.291 64.0722L18.9235 63.0623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5054 64.66L17.8467 65.2637L18.2142 66.2735L19.8729 65.6698L19.5054 64.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3416 61.4627L16.6829 62.0664L17.0504 63.0763L18.7091 62.4726L18.3416 61.4627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0873 66.2596L18.4286 66.8633L18.7962 67.8732L20.4549 67.2695L20.0873 66.2596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8325 71.0545L20.1738 71.6582L20.5413 72.6681L22.2 72.0644L21.8325 71.0545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2506 69.4549L19.5919 70.0586L19.9594 71.0684L21.6181 70.4647L21.2506 69.4549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4144 72.6521L20.7557 73.2559L21.1232 74.2658L22.7819 73.662L22.4144 72.6521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6686 67.8572L19.0099 68.4609L19.3775 69.4708L21.0362 68.8671L20.6686 67.8572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8477 54.7576L20.189 55.3613L20.5565 56.3712L22.2152 55.7675L21.8477 54.7576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.97 50.9861L75.3113 51.5898L75.6789 52.5997L77.3376 51.996L76.97 50.9861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5519 52.5838L75.8932 53.1875L76.2608 54.1974L77.9195 53.5937L77.5519 52.5838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3881 49.3865L74.7294 49.9902L75.0969 51L76.7556 50.3963L76.3881 49.3865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1037 45.201L46.4449 45.8047L46.8125 46.8146L48.4712 46.2109L48.1037 45.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8062 47.7889L74.1475 48.3926L74.515 49.4025L76.1737 48.7988L75.8062 47.7889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.643 44.5916L72.9843 45.1953L73.3518 46.2051L75.0105 45.6014L74.643 44.5916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.061 42.9939L72.4023 43.5977L72.7699 44.6076L74.4286 44.0038L74.061 42.9939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2249 46.1912L73.5662 46.7949L73.9337 47.8048L75.5924 47.2011L75.2249 46.1912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2185 58.5955L24.5598 59.1992L24.9273 60.2091L26.586 59.6054L26.2185 58.5955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.554 54.4607L40.8953 55.0645L41.2628 56.0744L42.9215 55.4706L42.554 54.4607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0563 50.6385L51.3976 51.2422L51.7652 52.2521L53.4239 51.6484L53.0563 50.6385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4307 51.5935L48.772 52.1973L49.1395 53.2072L50.7983 52.6034L50.4307 51.5935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0526 53.5213L58.3939 54.125L58.7615 55.1349L60.4202 54.5312L60.0526 53.5213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3038 51.6111L63.6451 52.2148L64.0127 53.2247L65.6714 52.621L65.3038 51.6111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6782 52.5662L61.0195 53.1699L61.3871 54.1798L63.0458 53.5761L62.6782 52.5662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0515 58.283L30.3928 58.8867L30.7604 59.8966L32.4191 59.2929L32.0515 58.283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3075 48.7264L56.6488 49.3301L57.0164 50.34L58.6751 49.7363L58.3075 48.7264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9331 47.7713L59.2744 48.375L59.642 49.3849L61.3007 48.7812L60.9331 47.7713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1321 58.9432L48.4734 59.5469L48.8409 60.5567L50.4996 59.953L50.1321 58.9432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2554 61.8103L40.5967 62.4141L40.9642 63.4239L42.6229 62.8201L42.2554 61.8103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5065 59.8982L45.8478 60.502L46.2153 61.5118L47.874 60.908L47.5065 59.8982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.881 60.8553L43.2223 61.459L43.5898 62.4688L45.2485 61.8651L44.881 60.8553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7577 57.9881L51.099 58.5918L51.4665 59.6016L53.1252 58.9979L52.7577 57.9881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6346 55.1209L58.9759 55.7246L59.3434 56.7344L61.0021 56.1307L60.6346 55.1209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3834 57.033L53.7247 57.6367L54.0922 58.6465L55.7509 58.0428L55.3834 57.033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0042 63.7225L35.3455 64.3262L35.7131 65.336L37.3718 64.7323L37.0042 63.7225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3786 64.6775L32.7199 65.2812L33.0874 66.2911L34.7461 65.6873L34.3786 64.6775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0969 50.9685L60.4382 51.5723L60.8058 52.5822L62.4645 51.9784L62.0969 50.9685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4713 51.9256L57.8126 52.5293L58.1802 53.5392L59.8389 52.9355L59.4713 51.9256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.515 49.3709L59.8563 49.9746L60.2239 50.9844L61.8826 50.3807L61.515 49.3709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8014 55.4334L53.1427 56.0371L53.5103 57.047L55.169 56.4433L54.8014 55.4334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6383 52.2381L51.9796 52.8418L52.3471 53.8516L54.0058 53.2479L53.6383 52.2381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2202 53.8357L52.5615 54.4395L52.929 55.4494L54.5877 54.8456L54.2202 53.8357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0126 53.1932L49.3539 53.7969L49.7214 54.8067L51.3801 54.203L51.0126 53.1932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5945 54.7908L49.9358 55.3945L50.3034 56.4044L51.9621 55.8007L51.5945 54.7908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7178 57.658L42.0591 58.2617L42.4267 59.2716L44.0854 58.6679L43.7178 57.658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9689 55.7478L47.3102 56.3516L47.6778 57.3615L49.3365 56.7577L48.9689 55.7478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8894 50.326L57.2307 50.9297L57.5983 51.9395L59.2569 51.3358L58.8894 50.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6735 60.2107L40.0148 60.8145L40.3823 61.8244L42.041 61.2206L41.6735 60.2107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2991 59.2557L42.6404 59.8594L43.008 60.8693L44.6667 60.2656L44.2991 59.2557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7967 63.0779L32.138 63.6816L32.5056 64.6915L34.1643 64.0878L33.7967 63.0779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.387 54.1482L46.7283 54.752L47.0958 55.7618L48.7545 55.158L48.387 54.1482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5502 57.3455L47.8915 57.9492L48.2591 58.9591L49.9178 58.3554L49.5502 57.3455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1759 56.3885L50.5172 56.9922L50.8847 58.0021L52.5434 57.3984L52.1759 56.3885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1359 56.0603L41.4772 56.6641L41.8447 57.6739L43.5034 57.0701L43.1359 56.0603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2601 54.1658L61.6014 54.7695L61.969 55.7793L63.6277 55.1756L63.2601 54.1658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6334 59.8826L30.9747 60.4863L31.3423 61.4961L33.001 60.8924L32.6334 59.8826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2153 61.4803L31.5566 62.084L31.9242 63.0939L33.5829 62.4902L33.2153 61.4803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9653 58.6307L54.3066 59.2344L54.6742 60.2443L56.3329 59.6406L55.9653 58.6307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0205 42.6619L63.3618 43.2656L63.7293 44.2754L65.388 43.6717L65.0205 42.6619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5551 49.699L68.8964 50.3027L69.2639 51.3126L70.9226 50.7089L70.5551 49.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9738 48.1014L68.3151 48.7051L68.6826 49.715L70.3413 49.1113L69.9738 48.1014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.137 51.2986L69.4783 51.9023L69.8458 52.9121L71.5045 52.3084L71.137 51.2986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7189 52.8963L70.0602 53.5L70.4278 54.5099L72.0865 53.9062L71.7189 52.8963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8099 44.9041L67.1512 45.5078L67.5188 46.5177L69.1775 45.914L68.8099 44.9041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3919 46.5037L67.7332 47.1074L68.1007 48.1172L69.7594 47.5135L69.3919 46.5037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3396 59.5857L51.6809 60.1895L52.0485 61.1994L53.7072 60.5956L53.3396 59.5857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5928 59.5525L21.9341 60.1562L22.3017 61.1661L23.9604 60.5624L23.5928 59.5525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0933 53.8533L67.4346 54.457L67.8021 55.4669L69.4609 54.8632L69.0933 53.8533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.714 60.5428L49.0553 61.1465L49.4229 62.1564L51.0816 61.5527L50.714 60.5428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2165 56.7205L59.5578 57.3242L59.9254 58.3341L61.5841 57.7304L61.2165 56.7205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4677 54.8084L64.809 55.4121L65.1765 56.422L66.8352 55.8183L66.4677 54.8084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0884 61.4978L46.4297 62.1016L46.7973 63.1115L48.456 62.5078L48.0884 61.4978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8421 55.7635L62.1834 56.3672L62.551 57.3771L64.2097 56.7734L63.8421 55.7635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8876 55.0857L29.2289 55.6895L29.5965 56.6993L31.2552 56.0955L30.8876 55.0857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0109 57.9529L21.3522 58.5566L21.7197 59.5664L23.3784 58.9627L23.0109 57.9529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6365 56.9978L23.9778 57.6016L24.3453 58.6114L26.004 58.0076L25.6365 56.9978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8924 47.4412L50.2337 48.0449L50.6012 49.0547L52.2599 48.451L51.8924 47.4412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7692 44.574L58.1105 45.1777L58.4781 46.1875L60.1368 45.5838L59.7692 44.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2668 48.3963L47.6081 49L47.9756 50.0098L49.6343 49.4061L49.2668 48.3963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8488 49.9959L48.1901 50.5996L48.5576 51.6095L50.2163 51.0058L49.8488 49.9959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4744 49.0389L50.8157 49.6426L51.1833 50.6525L52.842 50.0488L52.4744 49.0389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3512 46.1736L58.6925 46.7773L59.0601 47.7872L60.7188 47.1835L60.3512 46.1736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3482 49.0584L65.6895 49.6621L66.057 50.672L67.7157 50.0683L67.3482 49.0584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9295 50.6541L66.2708 51.2578L66.6383 52.2677L68.297 51.664L67.9295 50.6541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5114 52.2537L66.8527 52.8574L67.2202 53.8672L68.8789 53.2635L68.5114 52.2537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7662 47.4588L65.1075 48.0625L65.4751 49.0723L67.1338 48.4686L66.7662 47.4588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6024 44.2615L63.9437 44.8652L64.3113 45.8751L65.97 45.2714L65.6024 44.2615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1843 45.8611L64.5256 46.4648L64.8932 47.4747L66.5519 46.871L66.1843 45.8611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9642 63.3924L26.3055 63.9961L26.6731 65.006L28.3318 64.4023L27.9642 63.3924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8857 53.2088L64.2271 53.8125L64.5946 54.8223L66.2533 54.2186L65.8857 53.2088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9605 66.2752L33.3018 66.8789L33.6694 67.8888L35.3281 67.2851L34.9605 66.2752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7093 68.1873L28.0506 68.791L28.4182 69.8009L30.0769 69.1972L29.7093 68.1873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1274 66.5877L27.4687 67.1914L27.8362 68.2012L29.4949 67.5975L29.1274 66.5877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8373 63.41L41.1786 64.0137L41.5462 65.0236L43.2049 64.4199L42.8373 63.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5455 64.99L26.8868 65.5938L27.2544 66.6036L28.9131 65.9999L28.5455 64.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5861 65.3201L35.9274 65.9238L36.295 66.9337L37.9537 66.33L37.5861 65.3201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4696 56.6853L29.8109 57.2891L30.1785 58.299L31.8372 57.6952L31.4696 56.6853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4629 62.4529L43.8042 63.0566L44.1718 64.0665L45.8305 63.4628L45.4629 62.4529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3823 61.7928L25.7236 62.3965L26.0911 63.4063L27.7498 62.8026L27.3823 61.7928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8004 60.1951L25.1417 60.7988L25.5092 61.8087L27.1679 61.205L26.8004 60.1951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1017 43.324L81.443 43.9277L81.8106 44.9376L83.4693 44.3339L83.1017 43.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9379 40.1268L80.2792 40.7305L80.6467 41.7404L82.3054 41.1367L81.9379 40.1268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5198 41.7244L80.8611 42.3281L81.2286 43.3379L82.8873 42.7342L82.5198 41.7244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.683 44.9217L82.0243 45.5254L82.3919 46.5353L84.0506 45.9316L83.683 44.9217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.265 46.5193L82.6063 47.123L82.9738 48.1328L84.6325 47.5291L84.265 46.5193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4288 49.7166L83.7701 50.3203L84.1377 51.3302L85.7964 50.7265L85.4288 49.7166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8469 48.1189L83.1882 48.7227L83.5557 49.7326L85.2144 49.1288L84.8469 48.1189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0544 48.7615L86.3957 49.3652L86.7633 50.3751L88.422 49.7714L88.0544 48.7615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9558 73.9217L12.2971 74.5254L12.6646 75.5353L14.3233 74.9316L13.9558 73.9217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5377 75.5193L12.879 76.123L13.2465 77.1329L14.9052 76.5292L14.5377 75.5193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2658 53.158L19.6071 53.7617L19.9746 54.7715L21.6333 54.1678L21.2658 53.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0431 68.8123L16.3844 69.416L16.752 70.4259L18.4107 69.8222L18.0431 68.8123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.625 70.4119L16.9663 71.0156L17.3338 72.0254L18.9925 71.4217L18.625 70.4119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7888 73.6092L18.1301 74.2129L18.4977 75.2228L20.1564 74.6191L19.7888 73.6092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2069 72.0096L17.5482 72.6133L17.9158 73.6232L19.5745 73.0195L19.2069 72.0096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1775 51.6287L78.5188 52.2324L78.8864 53.2423L80.5451 52.6386L80.1775 51.6287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4318 46.8318L76.7731 47.4355L77.1406 48.4454L78.7993 47.8417L78.4318 46.8318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0137 48.4314L77.355 49.0352L77.7225 50.045L79.3812 49.4412L79.0137 48.4314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8505 45.2361L76.1918 45.8398L76.5593 46.8497L78.2181 46.246L77.8505 45.2361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5956 50.031L77.9369 50.6348L78.3045 51.6447L79.9632 51.041L79.5956 50.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2686 43.6365L75.6099 44.2402L75.9774 45.25L77.6361 44.6463L77.2686 43.6365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5217 43.6014L45.863 44.2051L46.2306 45.2149L47.8893 44.6112L47.5217 43.6014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5228 38.8396L73.8641 39.4434L74.2316 40.4532L75.8903 39.8494L75.5228 38.8396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1047 40.4392L74.446 41.043L74.8136 42.0529L76.4723 41.4491L76.1047 40.4392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6867 42.0369L75.028 42.6406L75.3955 43.6505L77.0542 43.0468L76.6867 42.0369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9409 37.242L73.2822 37.8457L73.6498 38.8555L75.3085 38.2518L74.9409 37.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8032 50.6736L81.1445 51.2773L81.512 52.2872L83.1707 51.6835L82.8032 50.6736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6838 51.5603L19.0251 52.1641L19.3927 53.1739L21.0514 52.5701L20.6838 51.5603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9398 42.0037L45.2811 42.6074L45.6487 43.6172L47.3074 43.0135L46.9398 42.0037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 71.367L14.3407 71.9707L14.7082 72.9805L16.3669 72.3768L15.9994 71.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2543 66.5721L12.5956 67.1758L12.9631 68.1856L14.6218 67.5819L14.2543 66.5721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8362 68.1697L13.1775 68.7734L13.5451 69.7833L15.2038 69.1796L14.8362 68.1697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4175 69.7674L13.7588 70.3711L14.1264 71.381L15.7851 70.7773L15.4175 69.7674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1632 74.5643L15.5045 75.168L15.8721 76.1779L17.5308 75.5741L17.1632 74.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5813 72.9646L14.9226 73.5684L15.2902 74.5783L16.9489 73.9745L16.5813 72.9646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2213 49.074L80.5626 49.6777L80.9301 50.6876L82.5888 50.0839L82.2213 49.074Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2535_1791",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 21,
    width: 73,
    height: 73
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9999,
    y: 21,
    width: 73,
    height: 73,
    rx: 4,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2535_1791)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.2499,
    y: 21.25,
    width: 72.5,
    height: 72.5,
    rx: 3.75,
    fill: "#1F1074",
    stroke: "#1F1074",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.238 49.9961H111.346C111.202 49.9961 111.085 50.1133 111.085 50.2578C111.085 50.4024 111.202 50.5196 111.346 50.5196H132.238C132.383 50.5196 132.5 50.4024 132.5 50.2578C132.5 50.1134 132.383 49.9961 132.238 49.9961Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6536 49.9961H42.7617C42.6172 49.9961 42.5 50.1133 42.5 50.2578C42.5 50.4024 42.6172 50.5196 42.7617 50.5196H63.6536C63.7982 50.5196 63.9154 50.4024 63.9154 50.2578C63.9155 50.1134 63.7982 49.9961 63.6536 49.9961Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2348 57.9927C69.9536 57.9927 69.7255 57.7647 69.7255 57.4833V48.2242C69.7255 47.9429 69.9535 47.7148 70.2348 47.7148C70.5161 47.7148 70.7442 47.9429 70.7442 48.2242V57.4833C70.7442 57.7646 70.5161 57.9927 70.2348 57.9927Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8802 54.0807C71.599 54.0807 71.3709 53.8528 71.3709 53.5714V48.9488C71.3709 48.6675 71.5989 48.4395 71.8802 48.4395C72.1615 48.4395 72.3896 48.6674 72.3896 48.9488V53.5714C72.3896 53.8527 72.1616 54.0807 71.8802 54.0807Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3674 53.184H65.2303C64.9869 53.184 64.7896 52.9866 64.7896 52.7432V48.1734C64.7896 47.8921 65.0176 47.6641 65.2989 47.6641C65.5801 47.6641 65.8082 47.892 65.8082 48.1734V52.7432C65.8082 52.9867 65.6108 53.184 65.3674 53.184Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6885 51.1449C86.4072 51.1449 86.1791 50.9169 86.1791 50.6356V42.691C86.1791 42.4097 86.4071 42.1816 86.6885 42.1816C86.9697 42.1816 87.1978 42.4096 87.1978 42.691V50.6356C87.1978 50.9168 86.9698 51.1449 86.6885 51.1449Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6884 41.5967C86.4072 41.5967 86.1791 41.3687 86.1791 41.0874V39.9019C86.1791 39.6207 86.4071 39.3926 86.6884 39.3926C86.9696 39.3926 87.1977 39.6206 87.1977 39.9019V41.0874C87.1977 41.3687 86.9697 41.5967 86.6884 41.5967Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6885 62.8025C86.4072 62.8025 86.1791 62.5745 86.1791 62.2932V51.9058C86.1791 51.6246 86.4071 51.3965 86.6885 51.3965C86.9697 51.3965 87.1978 51.6245 87.1978 51.9058V62.2933C87.1978 62.5745 86.9698 62.8025 86.6885 62.8025Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3337 57.768C88.0524 57.768 87.8243 57.54 87.8243 57.2586V45.2574C87.8243 44.9761 88.0524 44.748 88.3337 44.748C88.6149 44.748 88.843 44.976 88.843 45.2574V57.2586C88.843 57.5399 88.615 57.768 88.3337 57.768Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.043 47.1395C84.7617 47.1395 84.5336 46.9115 84.5336 46.6301V41.4605C84.5336 41.1793 84.7616 40.9512 85.043 40.9512C85.3242 40.9512 85.5523 41.1792 85.5523 41.4605V46.6301C85.5523 46.9115 85.3242 47.1395 85.043 47.1395Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.043 64.6102C84.7617 64.6102 84.5336 64.3822 84.5336 64.1009V48.0269C84.5336 47.7457 84.7616 47.5176 85.043 47.5176C85.3242 47.5176 85.5523 47.7456 85.5523 48.0269V64.1009C85.5523 64.3822 85.3242 64.6102 85.043 64.6102Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0126 55.2545H66.8755C66.6321 55.2545 66.4348 55.0571 66.4348 54.8137V48.0777C66.4348 47.7964 66.6627 47.5684 66.9441 47.5684C67.2253 47.5684 67.4534 47.7963 67.4534 48.0777V54.8137C67.4534 55.0571 67.2561 55.2545 67.0126 55.2545Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0126 47.1993H66.8755C66.6321 47.1993 66.4348 47.002 66.4348 46.7586V45.5992C66.4348 45.3179 66.6627 45.0898 66.9441 45.0898C67.2253 45.0898 67.4534 45.3178 67.4534 45.5992V46.7586C67.4534 47.002 67.2561 47.1993 67.0126 47.1993Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7524 62.27C82.0337 62.27 82.2617 62.042 82.2617 61.7607V36.5679C82.2617 36.2867 82.0337 36.0586 81.7524 36.0586C81.4712 36.0586 81.2431 36.2866 81.2431 36.5679V61.7607C81.2431 62.042 81.4711 62.27 81.7524 62.27Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7524 66.4758C82.0336 66.4758 82.2617 66.2478 82.2617 65.9664V63.2457C82.2617 62.9644 82.0337 62.7363 81.7524 62.7363C81.4711 62.7363 81.243 62.9643 81.243 63.2457V65.9664C81.2431 66.2477 81.4711 66.4758 81.7524 66.4758Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8163 64.4205C77.0975 64.4205 77.3256 64.1925 77.3256 63.9111V38.6187C77.3256 38.3375 77.0976 38.1094 76.8163 38.1094C76.535 38.1094 76.3069 38.3374 76.3069 38.6187V63.9112C76.3069 64.1925 76.5349 64.4205 76.8163 64.4205Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4617 54.7158C78.7429 54.7158 78.971 54.4877 78.971 54.2064V41.9664C78.971 41.6851 78.743 41.457 78.4617 41.457C78.1804 41.457 77.9523 41.685 77.9523 41.9664V54.2064C77.9523 54.4877 78.1804 54.7158 78.4617 54.7158Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4617 61.4513C78.7429 61.4513 78.971 61.2233 78.971 60.9419V55.4839C78.971 55.2027 78.7429 54.9746 78.4617 54.9746C78.1804 54.9746 77.9523 55.2026 77.9523 55.4839V60.9419C77.9523 61.2233 78.1804 61.4513 78.4617 61.4513Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1069 64.1298C80.3882 64.1298 80.6162 63.9018 80.6162 63.6205V45.8785C80.6162 45.5972 80.3883 45.3691 80.1069 45.3691C79.8257 45.3691 79.5976 45.5971 79.5976 45.8785V63.6206C79.5976 63.9018 79.8257 64.1298 80.1069 64.1298Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1069 44.9204C80.3881 44.9204 80.6162 44.6924 80.6162 44.411V40.8492C80.6162 40.5679 80.3882 40.3398 80.1069 40.3398C79.8256 40.3398 79.5975 40.5678 79.5975 40.8492V44.411C79.5975 44.6923 79.8256 44.9204 80.1069 44.9204Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1069 39.9045C80.3881 39.9045 80.6162 39.6765 80.6162 39.3952V38.2867C80.6162 38.0054 80.3882 37.7773 80.1069 37.7773C79.8256 37.7773 79.5975 38.0053 79.5975 38.2867V39.3952C79.5975 39.6764 79.8256 39.9045 80.1069 39.9045Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.171 59.0061C75.4522 59.0061 75.6803 58.7781 75.6803 58.4968V44.023C75.6803 43.7418 75.4523 43.5137 75.171 43.5137C74.8898 43.5137 74.6617 43.7417 74.6617 44.023V58.4968C74.6617 58.7781 74.8897 59.0061 75.171 59.0061Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3976 60.4483C83.6788 60.4483 83.9069 60.2203 83.9069 59.939V42.5875C83.9069 42.3062 83.6789 42.0781 83.3976 42.0781C83.1163 42.0781 82.8882 42.3061 82.8882 42.5875V59.9389C82.8882 60.2202 83.1162 60.4483 83.3976 60.4483Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5255 55.8727C73.2443 55.8727 73.0162 55.6447 73.0162 55.3634V47.1578C73.0162 46.8765 73.2442 46.6484 73.5255 46.6484C73.8067 46.6484 74.0348 46.8764 74.0348 47.1578V55.3634C74.0348 55.6446 73.8068 55.8727 73.5255 55.8727Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6534 51.702C63.3722 51.702 63.1441 51.474 63.1441 51.1926V49.6519C63.1441 49.3707 63.3721 49.1426 63.6534 49.1426C63.9347 49.1426 64.1627 49.3706 64.1627 49.6519V51.1926C64.1627 51.474 63.9347 51.702 63.6534 51.702Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.346 51.5261C111.065 51.5261 110.837 51.2981 110.837 51.0167V49.4761C110.837 49.1949 111.065 48.9668 111.346 48.9668C111.627 48.9668 111.855 49.1949 111.855 49.4761V51.0167C111.855 51.298 111.627 51.5261 111.346 51.5261Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6582 52.6439H68.5211C68.2777 52.6439 68.0803 52.4466 68.0803 52.2032V43.3101C68.0803 43.0289 68.3083 42.8008 68.5896 42.8008C68.8709 42.8008 69.099 43.0288 69.099 43.3101V52.2032C69.099 52.4466 68.9016 52.6439 68.6582 52.6439Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6582 58.6923H68.5211C68.2777 58.6923 68.0803 58.4949 68.0803 58.2515V53.6949C68.0803 53.4136 68.3083 53.1855 68.5896 53.1855C68.8709 53.1855 69.099 53.4136 69.099 53.6949V58.2515C69.099 58.4949 68.9016 58.6923 68.6582 58.6923Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.142 63.2703C102.861 63.2703 102.633 63.0423 102.633 62.761V40.2007C102.633 39.9195 102.861 39.6914 103.142 39.6914C103.423 39.6914 103.651 39.9194 103.651 40.2007V62.761C103.651 63.0422 103.423 63.2703 103.142 63.2703Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9151 61.7102C94.6339 61.7102 94.4058 61.4822 94.4058 61.2008V49.9566C94.4058 49.6753 94.6338 49.4473 94.9151 49.4473C95.1964 49.4473 95.4245 49.6752 95.4245 49.9566V61.2008C95.4245 61.4822 95.1965 61.7102 94.9151 61.7102Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.787 54.7243C104.506 54.7243 104.278 54.4964 104.278 54.215V43.6753C104.278 43.3941 104.506 43.166 104.787 43.166C105.068 43.166 105.297 43.394 105.297 43.6753V54.2151C105.296 54.4964 105.068 54.7243 104.787 54.7243Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.787 59.4045C104.506 59.4045 104.278 59.1765 104.278 58.8951V55.6597C104.278 55.3785 104.506 55.1504 104.787 55.1504C105.069 55.1504 105.297 55.3784 105.297 55.6597V58.8951C105.297 59.1765 105.069 59.4045 104.787 59.4045Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.497 48.9702C101.215 48.9702 100.987 48.7423 100.987 48.4609V46.6949C100.987 46.4136 101.215 46.1855 101.497 46.1855C101.778 46.1855 102.006 46.4135 102.006 46.6949V48.4609C102.006 48.7422 101.778 48.9702 101.497 48.9702Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.497 65.8765C101.215 65.8765 100.987 65.6485 100.987 65.3672V50.148C100.987 49.8668 101.215 49.6387 101.497 49.6387C101.778 49.6387 102.006 49.8667 102.006 50.148V65.3673C102.006 65.6485 101.778 65.8765 101.497 65.8765Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8512 61.8906C99.57 61.8906 99.3419 61.6626 99.3419 61.3813V49.7769C99.3419 49.4957 99.5699 49.2676 99.8512 49.2676C100.132 49.2676 100.361 49.4956 100.361 49.7769V61.3814C100.361 61.6626 100.132 61.8906 99.8512 61.8906Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.433 60.0024C106.152 60.0024 105.923 59.7745 105.923 59.4931V49.9566C105.923 49.6753 106.151 49.4473 106.433 49.4473C106.714 49.4473 106.942 49.6752 106.942 49.9566V59.4931C106.942 59.7745 106.714 60.0024 106.433 60.0024Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5607 56.0864C96.2794 56.0864 96.0513 55.8584 96.0513 55.5771V48.8941C96.0513 48.6128 96.2794 48.3848 96.5607 48.3848C96.8419 48.3848 97.07 48.6127 97.07 48.8941V55.5771C97.07 55.8583 96.842 56.0864 96.5607 56.0864Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5606 64.4633C96.2793 64.4633 96.0513 64.2352 96.0513 63.9539V56.9C96.0513 56.6187 96.2792 56.3906 96.5606 56.3906C96.8418 56.3906 97.0699 56.6186 97.0699 56.9V63.9539C97.0699 64.2352 96.8419 64.4633 96.5606 64.4633Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6245 55.1452C91.3432 55.1452 91.1152 54.9171 91.1152 54.6359V47.8804C91.1152 47.5992 91.3432 47.3711 91.6245 47.3711C91.9057 47.3711 92.1338 47.5991 92.1338 47.8804V54.6359C92.1338 54.9172 91.9057 55.1452 91.6245 55.1452Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9792 57.3939C89.698 57.3939 89.4699 57.1659 89.4699 56.8845V45.6402C89.4699 45.3589 89.6979 45.1309 89.9792 45.1309C90.2605 45.1309 90.4886 45.3588 90.4886 45.6402V56.8845C90.4885 57.1658 90.2605 57.3939 89.9792 57.3939Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2699 60.2129C92.9886 60.2129 92.7606 59.9849 92.7606 59.7035V51.4625C92.7606 51.1812 92.9885 50.9531 93.2699 50.9531C93.5511 50.9531 93.7792 51.1811 93.7792 51.4625V59.7035C93.7792 59.9849 93.5512 60.2129 93.2699 60.2129Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2058 60.1246C97.9245 60.1246 97.6965 59.8966 97.6965 59.6153V51.5425C97.6965 51.2613 97.9245 51.0332 98.2058 51.0332C98.487 51.0332 98.7151 51.2612 98.7151 51.5425V59.6153C98.715 59.8965 98.487 60.1246 98.2058 60.1246Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.723 52.9738C109.442 52.9738 109.214 52.7459 109.214 52.4645V48.0328C109.214 47.7515 109.442 47.5234 109.723 47.5234C110.005 47.5234 110.233 47.7514 110.233 48.0328V52.4645C110.233 52.7459 110.005 52.9738 109.723 52.9738Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.078 51.7617C107.797 51.7617 107.569 51.5337 107.569 51.2524V47.191C107.569 46.9097 107.797 46.6816 108.078 46.6816C108.359 46.6816 108.587 46.9096 108.587 47.191V51.2524C108.587 51.5336 108.359 51.7617 108.078 51.7617Z",
    fill: "#E9E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.078 54.5986C107.797 54.5986 107.569 54.3706 107.569 54.0892V52.5679C107.569 52.2867 107.797 52.0586 108.078 52.0586C108.359 52.0586 108.587 52.2866 108.587 52.5679V54.0892C108.587 54.3706 108.359 54.5986 108.078 54.5986Z",
    fill: "#E9E7F1"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1827 73.9376L69.2521 81.651C69.0695 81.7337 68.8714 81.7764 68.6711 81.7764C68.4708 81.7764 68.2727 81.7337 68.0901 81.651L64.8496 80.1741H63.4817L67.856 82.1669C68.1121 82.2832 68.39 82.3434 68.6711 82.3434C68.9522 82.3434 69.2301 82.2832 69.4862 82.1669L87.5506 73.9376H86.1827ZM86.1827 73.9376L69.2521 81.651C69.0695 81.7337 68.8714 81.7764 68.6711 81.7764C68.4708 81.7764 68.2727 81.7337 68.0901 81.651L64.8496 80.1741H63.4817L67.856 82.1669C68.1121 82.2832 68.39 82.3434 68.6711 82.3434C68.9522 82.3434 69.2301 82.2832 69.4862 82.1669L87.5506 73.9376H86.1827ZM86.1827 73.9376L69.2521 81.651C69.0695 81.7337 68.8714 81.7764 68.6711 81.7764C68.4708 81.7764 68.2727 81.7337 68.0901 81.651L64.8496 80.1741H63.4817L67.856 82.1669C68.1121 82.2832 68.39 82.3434 68.6711 82.3434C68.9522 82.3434 69.2301 82.2832 69.4862 82.1669L87.5506 73.9376H86.1827ZM132.129 54.4371C132.025 54.3331 131.911 54.24 131.788 54.1593C131.511 53.9788 131.193 53.8714 130.864 53.8471C130.534 53.8228 130.204 53.8824 129.904 54.0204L86.1827 73.9376L69.2521 81.651C69.0695 81.7337 68.8714 81.7764 68.6711 81.7764C68.4708 81.7764 68.2727 81.7337 68.0901 81.651L64.8496 80.1741L41.0625 69.3396L41.0569 69.3367L7.43823 54.0204C7.32185 53.9663 7.19982 53.9254 7.0744 53.8985C6.79814 53.8291 6.50986 53.8233 6.23105 53.8815C5.78502 53.9733 5.38411 54.2168 5.0959 54.571C4.80769 54.9253 4.6498 55.3686 4.64886 55.8262V127.016C4.64945 127.542 4.85763 128.046 5.22775 128.418C5.59787 128.791 6.09969 129 6.62312 129H130.719C131.243 129 131.744 128.791 132.114 128.418C132.485 128.046 132.693 127.542 132.693 127.016V55.8262C132.694 55.3066 132.492 54.8076 132.129 54.4371ZM132.129 127.016C132.129 127.392 131.98 127.752 131.716 128.018C131.452 128.284 131.093 128.433 130.719 128.433H6.62311C6.24915 128.433 5.89056 128.284 5.62613 128.018C5.3617 127.752 5.21308 127.392 5.21293 127.016V55.8262C5.21304 55.5893 5.27221 55.3562 5.38504 55.1482C5.49786 54.9402 5.66074 54.764 5.85879 54.6356C5.99816 54.5459 6.15169 54.4807 6.31283 54.4428C6.36032 54.4325 6.40837 54.4249 6.45674 54.4201C6.51182 54.4121 6.56744 54.4083 6.6231 54.4088C6.82362 54.409 7.02174 54.4525 7.2041 54.5363L40.3039 69.6145L41.0569 69.9575L63.4817 80.1741L67.856 82.1669C68.1121 82.2832 68.39 82.3434 68.6711 82.3434C68.9522 82.3434 69.2301 82.2832 69.4862 82.1669L87.5506 73.9376L130.138 54.5363C130.353 54.4386 130.588 54.3965 130.823 54.4138C131.058 54.4311 131.285 54.5074 131.483 54.6356C131.506 54.649 131.528 54.6642 131.548 54.6809C131.571 54.6955 131.592 54.7126 131.61 54.7319C131.773 54.8639 131.903 55.0306 131.993 55.2199C132.083 55.4093 132.129 55.6164 132.129 55.8262L132.129 127.016ZM86.1827 73.9376L69.2521 81.651C69.0695 81.7337 68.8714 81.7764 68.6711 81.7764C68.4708 81.7764 68.2727 81.7337 68.0901 81.651L64.8496 80.1741H63.4817L67.856 82.1669C68.1121 82.2832 68.39 82.3434 68.6711 82.3434C68.9522 82.3434 69.2301 82.2832 69.4862 82.1669L87.5506 73.9376H86.1827ZM86.1827 73.9376L69.2521 81.651C69.0695 81.7337 68.8714 81.7764 68.6711 81.7764C68.4708 81.7764 68.2727 81.7337 68.0901 81.651L64.8496 80.1741H63.4817L67.856 82.1669C68.1121 82.2832 68.39 82.3434 68.6711 82.3434C68.9522 82.3434 69.2301 82.2832 69.4862 82.1669L87.5506 73.9376H86.1827ZM40.3039 69.6145L41.0569 69.9575V69.3396L40.3039 69.6145ZM86.1827 73.9376L69.2521 81.651C69.0695 81.7337 68.8714 81.7764 68.6711 81.7764C68.4708 81.7764 68.2727 81.7337 68.0901 81.651L64.8496 80.1741H63.4817L67.856 82.1669C68.1121 82.2832 68.39 82.3434 68.6711 82.3434C68.9522 82.3434 69.2301 82.2832 69.4862 82.1669L87.5506 73.9376H86.1827Z",
    fill: "#695FA2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1745 81.626L7.8254 54.2803C6.50142 53.6804 4.99994 54.6484 4.99994 56.102V127C4.99994 128.105 5.89537 129 6.99994 129H131C132.105 129 133 128.105 133 127V56.102C133 54.6484 131.498 53.6804 130.174 54.2803L69.8254 81.626C69.3008 81.8637 68.6991 81.8637 68.1745 81.626Z",
    fill: "white",
    stroke: "#1F1074",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicecloningInterface);
export default __webpack_public_path__ + "static/media/voice cloning Interface.c8299408182f3d2b8b0b6739569cb841.svg";
export { ForwardRef as ReactComponent };